import type {
  CloudHttpRequest,
  CloudHttpResponse,
  DesktopCloudPlatform,
} from "@repo/shared/desktopCloud/types";
import { getWebApiBaseUrl } from "../lib/runtime";

const REFRESH_KEY = "jw_desktop_cloud_refresh";

async function browserHttpRequest(request: CloudHttpRequest): Promise<CloudHttpResponse> {
  const method = (request.method || "GET").toUpperCase();
  const res = await fetch(request.url, {
    method,
    headers: request.headers,
    body: request.body,
  });
  const body = await res.text();
  return { status: res.status, body };
}

/** Browser implementation of DesktopCloudPlatform (no Electron IPC / safeStorage). */
export function createBrowserCloudPlatform(): DesktopCloudPlatform {
  return {
    getBaseUrl: async () => getWebApiBaseUrl(),
    openExternalUrl: async (url) => {
      // Same-tab navigation for pairing so the user returns after approve when possible.
      window.open(url, "_blank", "noopener,noreferrer");
    },
    getRefreshToken: async () => {
      try {
        return localStorage.getItem(REFRESH_KEY);
      } catch {
        return null;
      }
    },
    setRefreshToken: async (token) => {
      try {
        if (token?.trim()) localStorage.setItem(REFRESH_KEY, token.trim());
        else localStorage.removeItem(REFRESH_KEY);
      } catch {
        /* ignore quota */
      }
    },
    httpRequest: browserHttpRequest,
  };
}
